<template>
  <div>
    <div id="template-solicitacao" v-if="ready">
      <FuncionalidadeHeader
        v-if="step && mostrarHeader"
        :custom-voltar="this.stepCount > 0 || customVoltar"
        :titulo="titulo"
        @click="voltar"
      />

      <template-steps v-if="step && mostrarHeader" :steps="template.steps" :cor-primaria="corPrimaria" :step-count="stepCount"/>

      <component :is="componenteAtivo"
                 :data="data[stepCount]"
                 :idTipoOcorrencia="idTipoOcorrencia"
                 :idFuncionalidade="idFuncionalidade"
                 :step="step"
                 :titulo="titulo"
                 :step-count="stepCount"
                 :step-end="template.steps.length - 2"
                 :beneficiarioSelecionado="beneficiarioSelecionado"
                 @bypass="tryBypass" @cancelar="cancelar" @proximo="proximo" @voltar="voltar" />

      <DialogDefault
        :open.sync="mostrarErro"
        title="Erro no envio"
        width="370px"
        @close="mostrarErro = false"
        :close-on-click-modal="false"
      >
        <template v-slot:title>
          <div />
        </template>
        <div>
          <div
            style="text-align: center; font: normal normal 600 18px/24px Open Sans; letter-spacing: 0; color: #333333; opacity: 1; margin-bottom: 20px;">
            Erro no envio
          </div>
          <div
            style="text-align: center; font: normal normal normal 14px/19px Open Sans; letter-spacing: 0; color: #000000; opacity: 0.8;">
            Não foi possível enviar seu formulário. <br>
            Verificar sua conexão e tente novamente
          </div>
          <ButtonDefault title="ENTENDI" @click="voltarStep" />
        </div>
      </DialogDefault>

      <DialogoConclusaoSolicitacao
        v-model="mostrarSucesso"
        :protocolo-sucesso="protocoloSucesso"
        @click="goToListagem"
      />
    </div>
  </div>
</template>

<script>
import { ConfiguradorResource } from '@/API'
import { mapActions, mapGetters, mapState } from 'vuex'
import TemplateStepDefault from '@/components/TemplateSolicitacao/steps/TemplateStepDefault'
import TemplateStepTermoDeUso from '@/components/TemplateSolicitacao/steps/TemplateStepTermoDeUso'
import TemplateStepGrupoFamiliar from '@/components/TemplateSolicitacao/steps/TemplateStepGrupoFamiliar'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import EnumTipoComponents from '@/components/TemplateSolicitacao/EnumTipoComponents'
import TemplateStepTipoSolicitacao from '@/components/TemplateSolicitacao/steps/TemplateStepTipoSolicitacao'
import TemplateStepFormulario from '@/components/TemplateSolicitacao/steps/TemplateStepFormulario'
import { formatPayloadSolicitacao } from '@/components/TemplateSolicitacao/TemplateSolicitacaoHelpers'
import TemplateStepFinalizar from '@/components/TemplateSolicitacao/steps/TemplateStepFinalizar'
import DialogDefault from '@/components/DialogDefault/DialogDefault'
import ButtonDefault from '@/components/buttons/ButtonDefault'
import TemplateStepIdentificacao from '@/components/TemplateSolicitacao/steps/TemplateStepIdentificacao'
import DialogoConclusaoSolicitacao from '@/components/TemplateSolicitacao/componentes/DialogoConclusaoSolicitacao'
import TemplateStepError from '@/components/TemplateSolicitacao/steps/TemplateStepError'
import TemplateSteps from '@/components/TemplateSolicitacao/TemplateSteps'

export default {
  name: 'TemplateSolicitacao',
  components: { TemplateStepError, TemplateSteps, DialogoConclusaoSolicitacao, ButtonDefault, DialogDefault, FuncionalidadeHeader, TemplateStepDefault },
  props: {
    idTemplate: {
      type: [Number, String],
      required: true
    },
    idFuncionalidade: {
      type: [Number, String],
      required: true
    },
    idTipoOcorrencia: {
      type: [Number, String],
      required: true
    },
    titulo: {
      type: String
    },
    listagemPopup: {
      type: Boolean,
      default: false
    },
    customVoltar: { type: Function },
    customCancelar: { type: Function },
    customFinalizar: { type: Function }
  },
  data () {
    return {
      showError: false,
      template: null,
      mostrarSucesso: false,
      protocoloSucesso: null,
      data: [],
      mostrarErro: false,
      bypass: true,
      finalizando: false,
      beneficiarioSelecionado: undefined,
      ready: false
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiSolicitacao']),
    ...mapGetters('SetupApp', ['bundle', 'estilo']),
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    queryEtapa () {
      let passoAtual = 0
      try {
        passoAtual = parseInt(this.$route.query.etapa)

        passoAtual = isNaN(passoAtual) ? 0 : passoAtual
      } catch (ignored) {
        passoAtual = -1
      }

      if (this.finalizando) {
        return this.template.steps.length - 1
      }

      return passoAtual
    },
    stepCount () {
      let passoAtual = this.queryEtapa
      if (passoAtual < 0) {
        passoAtual = 0
      }

      if (passoAtual > this.data.length) {
        return this.data.length
      }

      return passoAtual < 0 ? 0 : passoAtual
    },
    componenteAtivo () {
      if (!this.template) {
        return 'TemplateStepError'
      }

      return this.getComponentStep(this.step)
    },
    step () {
      if (!this.template) {
        return null
      }

      return this.template.steps[this.stepCount]
    },
    mostrarHeader () {
      return [
        EnumTipoComponents.encerramento
      ].indexOf(this.step.tipo) === -1
    }
  },
  methods: {
    ...mapActions('TempleteSolicitacaoStore', ['setRequestData', 'clean']),
    async init () {
      this.clean()
      await this.getConfig()
      this.ready = true
    },
    async getConfig () {
      this.template = await ConfiguradorResource.getTemplateSolicitacao({
        bundle: this.bundle,
        idTemplate: this.idTemplate
      })
      this.showError = !this.template
    },
    getComponentStep (step) {
      switch (step.tipo) {
        case EnumTipoComponents.termoDeUso:
          return TemplateStepTermoDeUso
        case EnumTipoComponents.grupoFamiliar:
          return TemplateStepGrupoFamiliar
        case EnumTipoComponents.tipoSolicitacao:
          return TemplateStepTipoSolicitacao
        case EnumTipoComponents.formulario:
          return TemplateStepFormulario
        case EnumTipoComponents.identificacao:
          return TemplateStepIdentificacao
        case EnumTipoComponents.encerramento:
          if (!this.finalizando) {
            this.finalizando = true
            this.finalizar()
          }
          return TemplateStepFinalizar
        default:
          return TemplateStepDefault
      }
    },
    async finalizar () {
      const payload = formatPayloadSolicitacao(this.template, this.idTipoOcorrencia, this.data)
      const result = await this.apiSolicitacao.enviarSolicitacao({
        payload,
        headers: {
          id_funcionalidade: this.idFuncionalidade
        },
        loading: false,
        handlerErrorIgnore: true
      })

      // eslint-disable-next-line no-console
      console.log(result)

      setTimeout(() => {
        if (result.status) {
          this.protocoloSucesso = {
            solicitacao: result.data,
            step: this.step,
            idFuncionalidade: this.idFuncionalidade
          }

          if (this.customFinalizar) {
            return this.customFinalizar()
          }

          if (this.listagemPopup) {
            this.setRequestData(this.protocoloSucesso)
            return this.goToListagem(result)
          }

          this.mostrarSucesso = true
          return
        }

        return this.falhaAoFinalizar(result)
      }, 1500)
    },
    goToListagem () {
      const location = {
        path: `/${this.idFuncionalidade}`
      }

      if (this.listagemPopup) {
        location.query = {
          novo: this.listagemPopup
        }
      }

      this.$router.push(location)
    },
    falhaAoFinalizar () {
      this.mostrarErro = true
    },
    tryBypass (payload) {
      this.proximo(payload)
    },
    proximo (payload) {
      this.bypass = true
      this.data[this.stepCount] = payload

      if (this.step.tipo === EnumTipoComponents.grupoFamiliar) {
        this.beneficiarioSelecionado = payload.beneficiario
      }

      const etapa = this.stepCount + 1

      if (payload.bypass) {
        return this.$router.replace({ query: { etapa: etapa, formularioAnterior: this.data[this.stepCount] } })
      }

      this.$router.push({ query: { etapa: etapa, formularioAnterior: this.data[this.stepCount] } })
    },
    voltarStep () {
      this.mostrarErro = false
      window.history.go(-1)
    },
    voltar () {
      if (this.customVoltar) {
        this.customVoltar()
      } else {
        this.$router.back()
      }
    },
    cancelar () {
      if (this.customCancelar) {
        this.customCancelar()
      } else {
        window.history.go(-1)
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="less">
#template-solicitacao {
  background: white;
  min-width: 75%;
  //box-shadow: 0 0 3px 0 dimgray;
  border-radius: 3px;
}
</style>
